class FAQs extends HTMLElement {
    constructor() {
        super();

        this.filter = document.getElementById('haloFAQsFilter');
        this.faqsPopup = document.getElementById('halo-faqs-popup');

        if(this.filter){
            this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
            this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
            this.filterDropdownArrow = this.filterToggle.querySelector('[data-dropdown-arrow]')
            
            if(this.filterToggle){
                this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
            }

            if(this.filterDropdown.querySelector('.text')){
                this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
                    filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
                });
            }
        }

        // if(this.querySelector('.faqs')){
        //     this.querySelectorAll('.card-header').forEach((headerButton) => {
        //         headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
        //     });
        // }

        if (this.querySelector('.faqs')) {
            const paragraphs = this.querySelectorAll('.faqs-paragraph');

            paragraphs.forEach((paragraph) => {
                const title = paragraph.querySelector('.faqs-title');
                const body = paragraph.querySelector('.faqs-body');

                // ✅ 默认折叠整个分类
                if (body) {
                    body.classList.add('is-collapsed');
                    body.style.maxHeight = null;
                }

                // ✅ 点击分类标题展开 / 收起
                if (title && body) {
                    title.addEventListener(
                        'click',
                        this.onClickFaqsTitleHandler.bind(this)
                    );
                }

                // ✅ FAQ 问题点击（你原来的逻辑）
                paragraph.querySelectorAll('.card-header').forEach((header) => {
                    header.addEventListener(
                        'click',
                        this.onClickHeaderButtonHandler.bind(this)
                    );
                });
            });
        }

        // if (this.querySelector('.faqs')) {
        //     const paragraphs = this.querySelectorAll('.faqs-paragraph');

        //     paragraphs.forEach((paragraph) => {
        //         const headers = paragraph.querySelectorAll('.card-header');

        //         headers.forEach((header, index) => {
        //             header.addEventListener(
        //                 'click',
        //                 this.onClickHeaderButtonHandler.bind(this)
        //             );

        //             // ✅ 每个分类前 2 个默认展开
        //             if (index < 2) {
        //                 const collapse = header.nextElementSibling;
        //                 const body = collapse?.querySelector('.card-body');

        //                 if (collapse && body) {
        //                     collapse.style.maxHeight = body.scrollHeight + 'px';
        //                     collapse.classList.add('show');
        //                     header.classList.remove('collapsed');
        //                 }
        //             }
        //         });
        //     });
        // }


        if(!document.body.classList.contains('template-index')){
            document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
        }

    }
    

    onClickFilterHandler(){
        if(this.filterDropdown.classList.contains('is-show')){
            this.filterDropdown.classList.remove('is-show');
            this.filterDropdownArrow.classList.remove('active')
        } else {
            this.filterDropdown.classList.add('is-show');
            this.filterDropdownArrow.classList.add('active')
        }
    }

    onClickFilterButtonHandler(event){
        var btn = event.target.closest('li');

        if(!btn.classList.contains('is-active')){
            var filterValue = btn.getAttribute('data-value'),
                filterText = event.target.innerText;

            this.filterToggle.querySelector('.text').innerText = filterText;

            this.filterDropdown.querySelectorAll('li').forEach((element) => {
                element.classList.remove('is-active');
            });

            btn.classList.add('is-active');

            if(filterValue !== undefined && filterValue !== null){
                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    var id = element.getAttribute('id');

                    if(id == filterValue){
                        element.classList.remove('is-hidden');
                        element.classList.add('is-active');
                    } else {
                        element.classList.remove('is-active');
                        element.classList.add('is-hidden');
                    }
                });
            } else {

                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    element.classList.remove('is-hidden', 'is-active');
                });
            }

            this.filterDropdown.classList.remove('is-show');
            this.filterDropdownArrow.classList.remove('active')
        }
    }

    onClickHeaderButtonHandler(event){
        const btn = event.currentTarget
        const content = btn.nextElementSibling

        btn.classList.toggle('collapsed');

        if (content.style.maxHeight){
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    // onClickHeaderButtonHandler(event) {
    //     const header = event.currentTarget;
    //     const collapse = header.nextElementSibling;

    //     if (!collapse || !collapse.classList.contains('collapse')) return;

    //     const body = collapse.querySelector('.card-body');
    //     const isOpen = collapse.classList.contains('show');

    //     if (isOpen) {
    //         // 关闭
    //         collapse.style.maxHeight = null;
    //         collapse.classList.remove('show');
    //         header.classList.add('collapsed');
    //     } else {
    //         // 打开
    //         collapse.style.maxHeight = body.scrollHeight + 'px';
    //         collapse.classList.add('show');
    //         header.classList.remove('collapsed');
    //     }
    // }

    onClickFaqsTitleHandler(event) {
        const title = event.currentTarget;
        const body = title.nextElementSibling;

        if (!body || !body.classList.contains('faqs-body')) return;

        const isOpen = !body.classList.contains('is-collapsed');

        if (isOpen) {
            body.style.maxHeight = null;
            body.classList.add('is-collapsed');
            title.classList.add('collapsed')
        } else {
            title.classList.remove('collapsed')
            body.classList.remove('is-collapsed');
            body.style.maxHeight = body.scrollHeight + 500 + 'px' ;
        }
    }


    onBodyClickEvent(event) {
        if (event.target.closest('[data-faqs-filter]') != null) return
        if(this.filterDropdown.classList.contains('is-show')) {
            this.filterDropdown.classList.remove('is-show')
            this.filterDropdownArrow.classList.remove('active')
        }
    }
}

customElements.define('faqs-item', FAQs);